import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { AmoService } from '@amo-widget/services/AmoService';
import ItemForm from '@integrations/components/modal-users-create-edit-form';
import i18n from '@app/plugins/i18n';

class AmoUserModalService extends ModalService {
  constructor() {
    super(AmoService);
  }

  edit(id, item) {
    return this.$open({
      title: i18n.t('integrations.modal.edit'),
      width: this.size.confirm,
      loading: true,
      render: h =>
        h(ItemForm, {
          props: {
            id: id,
            item: item,
            ip_disabled: true
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new AmoUserModalService();
export { instance as AmoUserModalService };
